import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const AddImportMap = () => {
  const navigate = useNavigate(); // Initialize navigate
  const [state, setState] = useState({
    procedureFrom: '',
    designMode: '',
    materialClass: '',
    procedureTo: '',
  });

  const [options] = useState({
    procedureFromOptions: ['Option 1', 'Option 2', 'Option 3'],
    designModeOptions: ['Option 1', 'Option 2', 'Option 3'],
    materialClassOptions: ['Option 1', 'Option 2', 'Option 3'],
    procedureToOptions: ['Option 1', 'Option 2', 'Option 3'],
  });

  const [errors, setErrors] = useState({
    procedureFrom: '',
    procedureTo: '',
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setState({
      ...state,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
  
    const newErrors = {
      procedureFrom: state.procedureFrom ? '' : 'Procedure From is required.',
      procedureTo: state.procedureTo ? '' : 'Procedure To is required.',
    };
  
    setErrors(newErrors);
  
    if (!newErrors.procedureFrom && !newErrors.procedureTo) {
      try {
        const response = await fetch('https://hms.backend.hiragroupcloud.com/api/import-map', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(state),
        });
  
        if (!response.ok) {
          throw new Error('Failed to submit form');
        }
  
        const data = await response.json();
        

        // Navigate to the OverviewSetting component
        navigate('/owersetting'); // Adjust the path if necessary
      } catch (error) {
        console.error('Error submitting form:', error);
      }
    }
  };

  return (
    <>
      <div style={{width:"1600px"}}>
            <div className="col-md-10">
              <h2 className="title">Add Import Map</h2> 
              <h5 style={{color:"#004aad"}}>
                From Primescan Procedure Matching Rule Procedure
              </h5>
              
              <form className="p-4 "  onSubmit={handleSubmit}>
                <div style={{backgroundColor:"#f4f4f4",padding:"10px",borderTop:"2px solid #004aad"}}>
                <div className="mb-3" style={{ marginBottom: '20px' }}>
                  <div className="form-group">
                    <label htmlFor="procedureFrom" style={{ fontWeight: 'bold' }}>Procedure*</label>
                    <select
                      className="form-control"
                      id="procedureFrom"
                      name="procedureFrom"
                      value={state.procedureFrom}
                      onChange={handleChange}
                    >
                      <option value="">Select Procedure</option>
                      {options.procedureFromOptions.map((option, index) => (
                        <option key={index} value={option}>{option}</option>
                      ))}
                    </select>
                    {errors.procedureFrom && <small className="text-danger">{errors.procedureFrom}</small>}
                  </div>
                </div>
                <div className="mb-3" style={{ marginBottom: '20px' }}>
                  <div className="form-group">
                    <label htmlFor="designMode" style={{ fontWeight: 'bold' }}>Design Mode</label>
                    <select
                      className="form-control"
                      id="designMode"
                      name="designMode"
                      value={state.designMode}
                      onChange={handleChange}
                    >
                      <option value="">Select Design Mode</option>
                      {options.designModeOptions.map((option, index) => (
                        <option key={index} value={option}>{option}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="mb-3" style={{ marginBottom: '20px' }}>
                  <div className="form-group">
                    <label htmlFor="materialClass" style={{ fontWeight: 'bold' }}>Material Class</label>
                    <select
                      className="form-control"
                      id="materialClass"
                      name="materialClass"
                      value={state.materialClass}
                      onChange={handleChange}
                    >
                      <option value="">Select Material Class</option>
                      {options.materialClassOptions.map((option, index) => (
                        <option key={index} value={option}>{option}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="mb-3" style={{ marginBottom: '20px' }}>
                  <div className="form-group">
                    <label htmlFor="procedureTo" style={{ fontWeight: 'bold' }}>To Labnet Procedure*</label>
                    <select
                      className="form-control"
                      id="procedureTo"
                      name="procedureTo"
                      value={state.procedureTo}
                      onChange={handleChange}
                    >
                      <option value="">Select Procedure To</option>
                      {options.procedureToOptions.map((option, index) => (
                        <option key={index} value={option}>{option}</option>
                      ))}
                    </select>
                    {errors.procedureTo && <small className="text-danger">{errors.procedureTo}</small>}
                  </div>
                </div>
                </div>
                <button type="submit" className="btn btn-primary mt-3" style={{backgroundColor:"#004aad",borderColor:'#004aad'}}>
                  Save
                </button>
              </form>
            </div>
          </div>
         
    </>
  );
};

export default AddImportMap;
